var SENTRY_RELEASE;SENTRY_RELEASE={name: "Mentor Coaching AI", version: "1.0.1"};